// removed by extract-text-webpack-plugin
module.exports = {"arrowWrapper":"_1lnXZj_ntlxU2T7ZOT-gP1","leftArrow":"_3nU4dGOO5ZBoePj2ZSXhWG","rightArrow":"rtd8CZL6qWY0BF7d5Bn3s","inlineGalleryArrow":"_1XyrIYlu7SXw5tsHTnwmD","projectsGallery":"_3QEng9eHiAfpi2t8RYL5_b","propertyInlineGallery":"HMUhsyiHUEhibBTssu1fW","cellGalleryArrow":"_2gNCMrPNFIJpKk5sa0cEAw","PropertyLightboxArrow":"hNqTYwU8xPwBaEmOstAm1","LightboxArrow":"_1qYg8mgWAv3hRMDlYODGvK","ReviewsArrow":"_1P5goX6YAywR01-P6C5wlJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryArrow/GalleryArrow.scss
// module id = 1609
// module chunks = 0